module.exports = __webpack_public_path__ + "54012bc6d42a9f0f22480c3ae49ae1ba.MP3";